import { TableColumnsType } from "antd"
import { IDataLicence } from "@/types/dags"
import { useGetDataLicences } from "@/hooks/useDags"
import dayjs from "dayjs"
import TableCustom from "@components/table"

const LicencesPage = () => {
  const { data, isLoading } = useGetDataLicences()

  const columns: TableColumnsType<IDataLicence> = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
    },
    {
      title: "Link",
      key: "link",
      dataIndex: "link",
      render: (text: string) => (
        <a href={text} target={"_blank"}>
          {" "}
          Open{" "}
        </a>
      ),
    },

    {
      title: "Date Created",
      key: "dateCreated",
      dataIndex: "dateCreated",
      render: (text: Date) => dayjs(text).format("DD/MM/YYYY"),
    },
  ]

  return (
    <div>
      <TableCustom
        rowKey={"_id"}
        columns={columns}
        dataSource={data}
        loading={isLoading}
        size={"small"}
      />
    </div>
  )
}

export default LicencesPage
